import React from "react";
import { Box, Typography } from "@mui/material";

const ChatBox = ({ message, isUser }) => {
  return (
    <Box className={isUser ? "flex-end" : "flex-row"} sx={{ p: 1.5 }}>
      <Box
        sx={{
          px: 2,
          py: 1,
          maxWidth: "80%",
          backgroundColor: isUser ? "#EDF3FF" : "#F3F6FD",
          borderRadius: isUser ? "30px 0px 50px 50px" : "0px 50px 50px 30px",
        }}
        className={`${isUser ? "user-message" : "bot-message"} message`}
      >
        <Box>
          <Typography className="font-12-400-lightgrey">
            {isUser ? "User" : "Bot"}
          </Typography>
          <Typography className="font-12-400-lightgrey" sx={{ ml: 1 }}>
            {message}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ChatBox;
